// WebMCP tools (ADR 0024): what an AI agent in the visitor's browser can do on this site, via
// document.modelContext.registerTool (Chrome; navigator.modelContext in early previews). No-op elsewhere.
// Forms in our own markup (filter bars, email start) are declarative tools instead (toolname attributes).
//
// - search_faq / list_faq_questions: the site's FAQs from /faq.json (modules/twig/FaqExtension.php)
// - get_clinic_contact: address and phone from the footer, and the booking page
// - fill_<form>_form: one per Pardot form on the page; pre-fills its visible fields through Pardot's query params
//   (window.wghi.formEmbed.prefill). Pardot forms are cross-origin, so the visitor still reviews and submits.
(function() {
    var modelContext = document.modelContext || navigator.modelContext;
    if ( !modelContext || typeof modelContext.registerTool !== 'function' ) {
        return;
    }

    var BOOKING_PATH = '/book-a-consultation/';
    var formTools = []; // [{tool, form}] registered by registerForms(), for get_clinic_contact
    var STOP_WORDS = ['the', 'and', 'for', 'are', 'you', 'your', 'can', 'how', 'what', 'does', 'with', 'will', 'from',
        'that', 'this', 'have', 'there', 'about', 'get', 'any', 'much', 'long', 'should', 'when', 'which', 'who'];

    function register(tool) {
        try {
            Promise.resolve(modelContext.registerTool(tool)).catch(function(error) {
                console.warn('WebMCP: could not register ' + tool.name, error);
            });
        } catch (error) {
            console.warn('WebMCP: could not register ' + tool.name, error);
        }
    }

    // ------------------------------------------------------------------ FAQ
    var faqRequest = null;
    function faqs() {
        faqRequest = faqRequest || fetch('/faq.json', { credentials: 'omit' }).then(function(response) {
            if ( !response.ok ) {
                throw new Error('FAQ request failed: ' + response.status);
            }
            return response.json();
        }).then(function(data) {
            return data.questions || [];
        }).catch(function(error) {
            faqRequest = null;
            throw error;
        });
        return faqRequest;
    }

    function words(text) {
        return (text.toLowerCase().match(/[a-z0-9]+/g) || []).filter(function(word) {
            return word.length > 2 && STOP_WORDS.indexOf(word) === -1;
        });
    }

    function formatFaq(faq) {
        return '### ' + faq.question + '\n' + faq.answer + (faq.url ? '\nSource: ' + faq.url : '');
    }

    register({
        name: 'search_faq',
        description: 'Search We Grow Hair Indy\'s frequently asked questions about hair loss, hair transplants (FUE, ARTAS, '
            + 'Multi-Unit Hair Grafting), non-surgical treatments, cost, financing, recovery and the clinic. Returns the '
            + 'best-matching questions with the clinic\'s own answers and the page each answer comes from.',
        inputSchema: {
            type: 'object',
            properties: {
                query: { type: 'string', description: 'What the visitor wants to know, e.g. "how long is recovery after FUE"' },
                limit: { type: 'integer', minimum: 1, maximum: 10, description: 'Maximum number of answers to return (default 5)' },
            },
            required: ['query'],
        },
        annotations: { readOnlyHint: true },
        execute: function(args) {
            var terms = words(args.query || '');
            var limit = Math.min(Math.max(parseInt(args.limit, 10) || 5, 1), 10);
            return faqs().then(function(list) {
                var scored = list.map(function(faq) {
                    var question = words(faq.question + ' ' + faq.topic);
                    var answer = words(faq.answer);
                    var score = terms.reduce(function(sum, term) {
                        var stem = term.replace(/(ing|es|s)$/, '');
                        var match = function(word) { return word.indexOf(stem) === 0; };
                        return sum + (question.some(match) ? 3 : 0) + (answer.some(match) ? 1 : 0);
                    }, 0);
                    return { faq: faq, score: score };
                }).filter(function(item) {
                    return item.score > 0;
                }).sort(function(a, b) {
                    return b.score - a.score;
                }).slice(0, limit);

                if ( !scored.length ) {
                    return 'No FAQ matched "' + args.query + '". Use list_faq_questions to see every question, or '
                        + 'suggest a free consultation: ' + location.origin + BOOKING_PATH;
                }
                return scored.map(function(item) { return formatFaq(item.faq); }).join('\n\n');
            });
        },
    });

    register({
        name: 'list_faq_questions',
        description: 'List the questions in We Grow Hair Indy\'s FAQ, grouped by topic (questions only; use search_faq '
            + 'for answers). Optionally only one topic.',
        inputSchema: {
            type: 'object',
            properties: {
                topic: { type: 'string', description: 'Only list topics whose name contains this text, e.g. "FUE" or "cost"' },
            },
        },
        annotations: { readOnlyHint: true },
        execute: function(args) {
            var filter = (args.topic || '').toLowerCase();
            return faqs().then(function(list) {
                var topics = {};
                list.forEach(function(faq) {
                    if ( !filter || faq.topic.toLowerCase().indexOf(filter) !== -1 ) {
                        (topics[faq.topic] = topics[faq.topic] || []).push('- ' + faq.question);
                    }
                });
                var names = Object.keys(topics);
                if ( !names.length ) {
                    return 'No FAQ topic matches "' + args.topic + '". Call again without a topic to see them all.';
                }
                return names.map(function(name) { return '## ' + name + '\n' + topics[name].join('\n'); }).join('\n\n');
            });
        },
    });

    // ------------------------------------------------------------------ Contact
    register({
        name: 'get_clinic_contact',
        description: 'Get We Grow Hair Indy\'s address, phone number and the page for booking a free hair restoration '
            + 'consultation (in person or virtual).',
        inputSchema: { type: 'object', properties: {} },
        annotations: { readOnlyHint: true },
        execute: function() {
            var contact = document.querySelector('.siteFooter__contact');
            var phone = contact && contact.querySelector('a[href^="tel:"]');
            var address = contact ? contact.innerText.replace(phone ? phone.innerText : '', '').trim().replace(/\s*\n\s*/g, ', ') : '';
            return [
                'We Grow Hair Indy',
                address ? 'Address: ' + address : null,
                phone ? 'Phone: ' + phone.innerText.trim() : null,
                'Book a free consultation: ' + location.origin + BOOKING_PATH,
                formTools.length ? 'Contact forms on this page: ' + formTools.map(function(item) {
                    return '"' + item.form + '" (tool ' + item.tool + ')';
                }).join(', ') + '. Offer to fill one in for the visitor; call the tool only if they ask, then they review '
                    + 'it and press Submit.' : null,
            ].filter(Boolean).join('\n');
        },
    });

    // ------------------------------------------------------------------ Pardot forms
    function slug(text) {
        return (text || 'contact').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 48);
    }

    function registerForms() {
        var used = {};
        document.querySelectorAll('[data-form-embed][data-form-fields]').forEach(function(placeholder) {
            var fields;
            try {
                fields = JSON.parse(placeholder.getAttribute('data-form-fields')) || [];
            } catch (error) {
                fields = [];
            }
            if ( !fields.length || !window.wghi.formEmbed ) {
                return;
            }
            var formName = placeholder.getAttribute('data-form-name') || placeholder.getAttribute('data-title');
            var name = 'fill_' + slug(formName) + '_form';
            used[name] = (used[name] || 0) + 1;
            if ( used[name] > 1 ) {
                name = name.replace(/_form$/, '_' + used[name] + '_form');
            }
            formTools.push({ tool: name, form: formName });

            var properties = {};
            fields.forEach(function(field) {
                var property = { type: 'string', title: field.label, description: field.label + (field.required ? ' (required)' : '') };
                if ( field.name === 'email' || field.type === 'email' ) {
                    property.format = 'email';
                }
                if ( field.options && field.options.length ) {
                    property.enum = field.options;
                }
                properties[field.name] = property;
            });

            register({
                name: name,
                // The visitor asking the agent to fill the form is their consent to share these details with the clinic
                // (they're sent to Pardot in the iframe URL as soon as it loads). ADR 0024.
                description: 'Fills in the "' + formName + '" form on this page (We Grow Hair Indy\'s form for contacting '
                    + 'the clinic) with the visitor\'s details, so they don\'t have to type them. Let the visitor know you can '
                    + 'do this when they want to contact the clinic, book a consultation or ask a question. Only call it when '
                    + 'the visitor asks you to fill in the form, and only with details they have given you for it: their '
                    + 'details go to We Grow Hair Indy as soon as the form is filled. It does not submit the form: afterwards, '
                    + 'tell the visitor to review it and press Submit.',
                inputSchema: {
                    type: 'object',
                    properties: properties,
                    required: fields.filter(function(field) { return field.required; }).map(function(field) { return field.name; }),
                },
                execute: function(args) {
                    var values = {};
                    fields.forEach(function(field) {
                        if ( args[field.name] != null && String(args[field.name]).trim() !== '' ) {
                            values[field.name] = String(args[field.name]).trim();
                        }
                    });
                    window.wghi.formEmbed.prefill(placeholder, values);
                    var filled = fields.filter(function(field) { return values[field.name]; }).map(function(field) { return field.label; });
                    return 'Filled in ' + (filled.join(', ') || 'no fields') + ' on the "' + formName + '" form and scrolled to it. '
                        + 'It has NOT been submitted: ask the visitor to review the form and press its Submit button.';
                },
            });
        });
    }

    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', registerForms) : registerForms();
})();
